module.exports = __webpack_public_path__ + "img/mile1m-m@1.7375a29f.jpg";